export const StringUtils = {

  upperFirst: text => !text || !text.length ? text : text.trim().charAt(0).toUpperCase() + text.trim().slice(1),

  abreviaString (string, tamanho) {
    return string.substring(0, tamanho) + '...'
  }
}

export default StringUtils
